import { Configuration } from '@types'
import { selectCredentials } from '../../loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import {
  UpdateAgentAssignmentPoolAction,
  UpdateConfigurationAction,
  getAgentAssignmentPool,
  getAgentAssignmentPoolFailed,
  getAgentAssignmentPoolSuccess,
  getConfigurations,
  getConfigurationsFailed,
  getConfigurationsSuccess,
  updateAgentAssignmentPool,
  updateAgentAssignmentPoolFailed,
  updateAgentAssignmentPoolSuccess,
  updateConfiguration
} from './configurationsSlice'
import {
  getAgentAssignmentPoolOverviewService,
  getConfigurationsService,
  updateAgentAssignmentPoolService,
  updateConfigurationService
} from '../../../http/configurationsService'
import { AgentAssignmentPoolOverview } from '@types'

export function* configurationsHttp() {
  const { cocap } = yield select(selectCredentials)
  try {
    const configurations: Configuration[] = yield call(getConfigurationsService, cocap)
    yield put(getConfigurationsSuccess(configurations))
  } catch (e) {
    yield put(getConfigurationsFailed(e.message))
  }
}

export function* updateConfigurationsHttp({ payload }: UpdateConfigurationAction) {
  const { cocap } = yield select(selectCredentials)
  try {
    yield call(updateConfigurationService, payload.name || '', cocap, payload)
    yield put(getConfigurations())
  } catch (e) {
    yield put(getConfigurationsFailed(e.message))
  }
}

export function* getAgentAssignmentPoolHttp() {
  const { cocap } = yield select(selectCredentials)
  try {
    const overview: AgentAssignmentPoolOverview = yield call(getAgentAssignmentPoolOverviewService, cocap)
    yield put(getAgentAssignmentPoolSuccess(overview))
  } catch (e) {
    yield put(getAgentAssignmentPoolFailed(e.message))
  }
}

export function* updateAgentAssignmentPoolHttp({ payload }: UpdateAgentAssignmentPoolAction) {
  const { cocap } = yield select(selectCredentials)
  try {
    const overview: AgentAssignmentPoolOverview = yield call(updateAgentAssignmentPoolService, cocap, payload)
    yield put(updateAgentAssignmentPoolSuccess(overview))
  } catch (e) {
    yield put(updateAgentAssignmentPoolFailed(e.message))
  }
}

export default function* configurationsSaga() {
  yield takeEvery(getConfigurations.type, configurationsHttp)
  yield takeEvery(updateConfiguration.type, updateConfigurationsHttp)
  yield takeEvery(getAgentAssignmentPool.type, getAgentAssignmentPoolHttp)
  yield takeEvery(updateAgentAssignmentPool.type, updateAgentAssignmentPoolHttp)
}
